import { Column, FMColumn } from '../model';

import { SelectorCell } from '../components/cells/SelectorCell';
import { SelectorHeader } from '../components/cells/SelectorHeader';

import { Type } from '../../../../general/modules/filter/dataModel';

export const selectorCol: FMColumn<Type.NONE> = {
  key: Column.selector,
  dataKey: Column.selector,
  title: '',
  width: 50,
  // Чекбокс и имя закреплены слева: при горизонтальной прокрутке широкой
  // таблицы (в папке бывает больше десятка колонок) иначе уезжает и то, что
  // выбираешь, и то, что читаешь, — остаются одни безымянные значения.
  fixed: 'left',
  sortable: false,
  cellRenderer: SelectorCell,
  headerRenderer: SelectorHeader,
  className: 'ch-file-manager__cell_selector',
  headerClassName: 'ch-file-manager__header-cell_selector',
  getter: () => null,
  toDisplayString: () => null,
};
